import { useProjectTasksDataTable } from 'generated/resources/datatable.graphql'

import { statusFilter } from './status'

export const filters = (source: ReturnType<typeof useProjectTasksDataTable>) => [
  statusFilter(source),
]
